// LE Data App Standard. Presentation colours only; no metric or source semantics.
export const reportPalette = {
  teal: '#0F464F',
  mint: '#4EFEB9',
  beige: '#F9F7F1',
  white: '#FFFFFF',
  black: '#0F0C08',
  quiet: '#F3F1EA',
  border: 'rgba(15,12,8,.14)',
} as const;
// One metric across named products: mint marks the largest positive value in the current scope.
// A teal outline keeps the mint bar distinguishable against the white plot.
export function productColour(name: string, leadingName?: string): string {
  return name === leadingName ? reportPalette.mint : reportPalette.teal;
}
